requirejs.config({
    "baseUrl": "/Areas/Shared/Static/js",
    "paths": {
        "jquery": "lib/jquery-3.6.0",
        "jquery-ui": "lib/jquery-ui",
        "jquery-unobtrusive": "lib/jquery.unobtrusive-ajax.min",
        "lodash": "lib/lodash",
        "moment": "lib/moment",
        "moment.fr": "../localization/moment_locales/fr",
        "moment.it": "../localization/moment_locales/it",
        "moment-locales": "../localization/moment-locales",
        "bootstrap": "lib/bootstrap",
		"bootstrap.datetimepicker": "lib/bootstrap-datetimepicker",
        "bootstrap.datepicker": "lib/bootstrap-datepicker",
        "bootstrap.datepicker.fr": "../localization/bootstrap_datepicker/fr",
        "bootstrap.datepicker.it": "../localization/bootstrap_datepicker/it",
        "bootstrap.datepicker-locales": "../localization/bootstrap.datepicker-locales",
        "bluebird": "lib/bluebird",
        "modernizr": "lib/modernizr-custom",
        "spectrum": "lib/spectrum",
        "datatables.net": "lib/jquery.dataTables",
		"datatables.bootstrap": "lib/dataTables.bootstrap",
		"datatables.bootstrap4": "lib/dataTables.bootstrap4",
        "dataTables.fixedHeader.min": "lib/dataTables.fixedHeader.min",
		"libloadingoverlay": "lib/loadingoverlay",
		"loadingoverlay": "quantaloadingoverlay",
        "ammaps": "lib/ammap/ammap",
        "ammaps.fr": "lib/ammap/lang/fr",
        "ammaps.uk": "lib/ammap/lang/uk",
        "ammaps-world": "lib/ammap/maps/js/worldLow",
		//"fancytree": "lib/jquery.fancytree",
		//"fancytree-glyph": "lib/jquery.fancytree.glyph",
		"fancytree": "lib/fancytree-2.38.0/modules/jquery.fancytree",
		"fancytree-glyph": "lib/fancytree-2.38.0/modules/jquery.fancytree.glyph",
		"fancytree-ui-deps": "lib/fancytree-2.38.0/modules/jquery.fancytree.ui-deps",

        "quantasaw": "quantasaw",
        "quantatree": "quantatree",
        "quantatree2": "quantatree2",
        "datatables.render.methods": "datatables.render.methods",
        "uri": "lib/URI/URI",
        "punycode": "lib/URI/punycode",
        "IPv6": "lib/URI/IPv6",
        "SecondLevelDomains": "lib/URI/SecondLevelDomains",
        "financialItem.shared": "financialItem.shared",
        "amcharts.shared": "amcharts.shared",
        "amcharts": "lib/amcharts/amcharts",
        "amstock": "lib/amcharts/amstock",
        "amcharts.funnel": "lib/amcharts/funnel",
        "amcharts.gauge": "lib/amcharts/gauge",
        "amcharts.pie": "lib/amcharts/pie",
        "amcharts.radar": "lib/amcharts/radar",
        "amcharts.serial": "lib/amcharts/serial",
        "amcharts.xy": "lib/amcharts/xy",
        "amcharts.gantt": "lib/amcharts/gantt",
        "amcharts.fr": "../localization/amcharts/fr",
        "amcharts.it": "../localization/amcharts/it",
		"amcharts.en": "../localization/amcharts/en",
        "history": "lib/history",
        "PortTransac_EditCompo": "../../../Portefeuille/Static/Editer/PortTransac_EditCompo",
        "wizard": "wizard-slider",
        "wizard-plus": "wizard-plus",
        "frontiere": "frontiere",
        "scenario": "scenario",
        "composition": "composition",
		"bootstrap.notify": "lib/bootstrap-notify",
		"quantanotify": "quantanotify",
        "parsley": "lib/parsley",
        "parsley.fr": "../localization/parsley/fr",
        "parsley.validators": "parsley.validators",
        "menu-quantalys": "menu-quantalys",
        "tether": "lib/tether/tether",
        "drop": "lib/tether/drop", 
        "quantaTabbedGrid" : "quantaTabbedGrid", 
        //"quantasearch": "../../../Recherche/quantasearch",  //n'existe plus
        //"quantasearch2": "../../../Recherche/quantasearch2", //remplacé par la version quantasearchTG
		"quantasearch2": "../../../Recherche/quantasearchTG",
		"quantacomp": "../../../Comparaison/Static/quantacompBO_split", //implementation officielle pour $quantacomp dans quantalys
		"quantacomp_ecureuilvie": "../../../Comparaison/Static/quantacompBO_split_ecureuilvie", 
		"quantacomp_old": "../../../Comparaison/Static/old/quantacomp", //ancienne version pre .ts en un seul fichier utilisée avec monaxa
        "velocity": "lib/velocity/velocity",
        "velocity-ui": "lib/velocity/velocity.ui",
        "qtjs.binder": "binder",
        "ajax-promise": "ajax-promise",
        "range-date-bar": "range-date-bar",
        "error-handler": "error-handler",
        "selenium-helper": "selenium-helper",
        "register-global-error-handler": "register-global-error-handler",
        "typeahead": "lib/typeahead",
        "quanta-table-crud": "quanta-table-crud",
        "dom-to-obj": "dom-to-obj",
        "EditeurProduit": "EditeurProduit",
        "quanta-form-validator": "quanta-form-validator",
        "quanta-form-validator.fr": "../localization/quanta_form_validator/fr",
        "quanta-form-validator.it": "../localization/quanta_form_validator/it",
        "quanta-form-validator-locales": "../localization/quanta-form-validator-locales",
        "responsive-tabs": "lib/responsive-tabs",
        "ag2r-override": "/Areas/Partenaire/Easypack/AG2REasypack/Static/ag2r-override",
        "jsonview": "lib/jquery.jsonview",
        "quantaswitch": "quantaswitch",
        "js.cookie": "lib/js.cookie",
        "quantabox": "quantabox",
        "modele-pdf-downloader": "modele-pdf-downloader",
        "carousel": "carousel_",
		"carousel2": "carousel.2.0_",
        "FinancialItem": "FinancialItem",
        "ItemCourbe": "ItemCourbe",
        "Enum": "Enum",
		"quantatimespan": "quantatimespan",
		"quantasimpletimespan": "quantaSimpleTimespan",
        "quantapie": "graphs/quantapie",
		"quantapie4": "graphs/quantapie4",
        "quantanuage": "graphs/quantanuage",
		"quantanuage4": "graphs/quantanuage4",
		"quantamap4": "graphs/quantamap4",
		"quantacone4": "graphs/quantacone4",
        "quantaline": "graphs/quantaline",
		"quantacharts4": "graphs/quantacharts4",
		"quantagauge4": "graphs/quantagauge4",
        "quantatab": "quantatab",
        "color-manager": "color-manager",
        "quantamodule": "quantamodule",
        "propositionAllocationCreation": "Natixis/PropositionAllocationCreation",
        'amcharts.plugins.animate': 'lib/amcharts/plugins/animate',
        'amcharts.plugins.dataloader': 'lib/amcharts/plugins/dataloader',
        'amcharts.plugins.export': 'lib/amcharts/plugins/export',
        'amcharts.plugins.responsive': 'lib/amcharts/plugins/responsive',
        'bootstrap-override': 'bootstrap-override',
		'ventilation': 'ventilation',
		'ventilation-typed': 'ventilation-typed',
        'quantaaffix': 'quantaaffix',
        "fileupload": "file-upload/jquery.fileupload",
        "jquery-fileupload-process": "file-upload/jquery.fileupload-process",
        "jquery-iframe-transport": "file-upload/jquery.iframe-transport",
        "quantaUpdate": "quantaUpdate",
        "i18n": "i18n",
        "utilities": "Utilities",
        "jquery.extend": "jquery.extend",
		"datatables.sort.extensions": "datatables.sort.extensions",
        "clipboard": "lib/clipboard",
        "allocation-class": "AllocationActifs/AllocationClass",
        "allocation-optimisation": "AllocationActifs/AllocationOptimisation",
        "allocation-manuelle": "AllocationActifs/AllocationManuelle",
        "error-display": "error-display",
        "sceditor": "SCEditor/sceditor.min",
        "quantawysiwyg": "EditeurWysiwyg/quantawysiwyg",
        "editeurwysiwygparser": "EditeurWysiwyg/BBCodeHtmlParser",
        "htmlCleaner": "EditeurWysiwyg/HtmlCleaner",
        "htmlEditor": "EditeurWysiwyg/HtmlEditor",
        "quantatooltip": "quantatooltip",
        "codeMirror": "lib/codemirror/codemirror",
        "codeMirrorHtmlMixed": "lib/codemirror/mode/htmlmixed/htmlmixed",
        "pdfJs": "lib/pdfJs/pdf",
        "pdfJs-worker": "lib/pdfJs/pdf.worker",
        "quanta-pub": "quanta-pub",
        "tweenmax": "https://cdnjs.cloudflare.com/ajax/libs/gsap/1.20.3/TweenMax.min",
        "QuantaNumber": "quantanumber",
        "QuantaFormNumber": "quanta-form-number",
        "columnchart": "graphs/column-chart",
        "dragscroll": "lib/dragscroll",
        "quantaresizable": "EditeurWysiwyg/quantaresize",
        "bassin": "bassin",
        "NotifyClientActionExecuted": "NotifyClientActionExecuted",
        "iMask": "lib/imask",
        "map": "map",
        "quantainputfile": "quantainputfile",
        "societegestion": "/Areas/SocieteDeGestion/Static/Js/Admin/SocieteGestion",
        "quantasearch.extension": "../../../Recherche/quantasearch.extension",
        "ckeditor": "EditeurWysiwyg/CKEditor_4/ckeditor",
        "ckeditorJqueryAdapters":"EditeurWysiwyg/CKEditor_4/adapters/jquery",
        "wysiwyg": "EditeurWysiwyg/wysiwyg",
        "qunit": "qunit-2.9.2",
        "quantadatatable": "/Areas/Shared/Static/js/quantadatatable",
        "leaflet": "lib/Leaflet/leaflet-src",
        "quill": "lib/quill",
        "slick": "lib/slick",
        "jodit": "lib/jodit.min",
        "dragula": "lib/dragula",
        "markjs": "lib/markjs/jquery.mark",
        "i18n-tools": "i18nTools/i18n-tools",
		"i18nSite-messaging": "i18nTools/i18nSite-messaging", //original version for traduc site without browse
		"i18nSite-messaging-postmate": "i18nTools/i18nSite-messaging-postmate", //modified version with postmate for traduc "browse" page
		"popper": "lib/popper",
		"postmate": "lib/postmate_modified",
		"tooltip": "lib/tooltip",
		"currencyHelper" : "currencyHelper",
		"text": 'requirejsPlugins/lib/text', //text is required by json requirejs plugin
		"json": 'requirejsPlugins/json', //json requirejs plugin (pour loader des fichier json, comme les maps d'amcharts4)
		"chars-restants": "chars-restants",
		"polyfill-focus-visible": "lib/polyfill-focus-visible",
		"ifvisible":"lib/ifvisible/ifvisible_2.0.10.min",
		"AxaDERuleModule": "Axa/Drouot Estate/RuleModule",
		"AxaDEPuceModule": "Axa/Drouot Estate/AxaDE_PuceModule",
		"csrf-token": "csrf-token",
		"fluentvalidation": "FluentValidation/fluentvalidation",
		"signalr.core": "lib/jquery.signalR-2.4.1",
		"signalr.hubs": "/signalr/hubs?",
		"fluentvalidation": "FluentValidation/fluentvalidation",
		"formDataCollector": "formDataCollector",
		"intlTelInput": "lib/intl-tel-input/js/intlTelInput",
		"redirection": "redirection",
		"filteredcolumns": "filteredcolumns",
		"bootstrap4": "lib/bootstrap4/bootstrap.bundle.4.6.0",
		"cleavejs": "lib/cleave/cleave.1.6.0",
		"flatpickr": "lib/flatpickr/flatpickr",
		"flatpickr.fr": "lib/flatpickr/l10n/fr",
		"flatpickr.it": "lib/flatpickr/l10n/it",
		"flatpickr.nl": "lib/flatpickr/l10n/nl",
		"swiper": "lib/swiper-bundle",
		"dropzone": "lib/dropzone-amd-module",
		"select2": "lib/select2/select2.full",
        "ventilationEditor": "../../../Standard/Operations/Ventilation/VentilationEditor",
		"ageSelection": "ageSelection",
		},
	"packages":
	[
		{
			name: "formvalidation",
			main: "index",
			location: "lib/formvalidation"
		}
	],
	"shim": {
		"datatables.bootstrap": {
			"deps": ["datatables.net"]
		},
		"datatables.bootstrap4": {
			"deps": ["datatables.net"]
		},
		"jquery-ui": {
			"deps": ['jquery']
		},
        "jquery-ui": {
            "deps": ['jquery']
        },
        "jquery-unobtrusive": {
            "deps": ['jquery']
        },
        "bootstrap": {
            "deps": ['jquery']
        },
        "jsonview": {
            "deps": ['jquery']
        },
        "spectrum": {
            "deps": ['jquery']
        },
        "moment.fr":{
            "deps": ['moment']
        },
        "moment.it": {
            "deps": ['moment']
        },
        "amcharts.fr": {
            "deps": ['amcharts']
        },
        "amcharts.it": {
            "deps": ['amcharts']
        },
		"amcharts.en": {
			"deps": ['amcharts']
		},
        "ammaps-world": {
            "deps": ['amcharts']
        },
        "ammaps": {
            "deps": ['ammaps-world']
        },
        "ammaps.fr": {
            "deps": ['ammaps']
        },
        "map": {
            "deps": ['ammaps']
        },
        //"bootstrap.datepicker": {
        //    "deps": ['bootstrap']
        //},
        "bootstrap.datepicker.fr": {
            "deps": ['bootstrap.datepicker']
        },
        "bootstrap.datepicker.it": {
            "deps": ['bootstrap.datepicker']
        },
        //"fancytree": {
        //    "deps": ['jquery', 'jquery-ui'] //"fancytree-ui-deps"]
        //},
        //"fancytree-glyph": {
        //    "deps": ['jquery', 'fancytree']
        //},
        "tablesaw": {
            "deps": ['jquery']
        },
        "quantaUpdate": {
            "deps": ['jquery']
        },
        "loadingoverlay": {
            "deps": ['jquery', 'bluebird']
        },
        'Modernizr': {
            "exports": 'Modernizr'
        },
        "velocity": {
            deps: [ "jquery" ]
        },
        "velocity-ui": {
            deps: ["velocity"]
        },
        'parsley.fr':{
            "deps" : ['parsley']
        },
        'ckeditor': {
            "exports": "CKEDITOR"
        },
        'ckeditorJqueryAdapters': {
            "deps": ['ckeditor']
        },
        'amcharts.funnel': {
            deps: ['amcharts'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amcharts.gauge': {
            deps: ['amcharts'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amcharts.pie': {
            deps: ['amcharts'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amcharts.radar': {
            deps: ['amcharts'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amcharts.serial': {
            deps: ['amcharts'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amcharts.xy': {
            deps: ['amcharts'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amcharts.gantt': {
            deps: ['amcharts', 'amcharts.serial'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amstock': {
            deps: ['amcharts', 'amcharts.serial'],
            exports: 'AmCharts',
            init: function () {
                AmCharts.isReady = true;
            }
        },
        'amcharts.plugins.animate': {
            deps: ['amcharts']
        },
        'amcharts.plugins.dataloader': {
            deps: ['amcharts']
        },
        'amcharts.plugins.export': {
            deps: ['amcharts']
        },
        'amcharts.plugins.responsive': {
            deps: ['amcharts']
        },
        'markjs': {
            deps: ['jquery']
		},
		'lib/amcharts4/core': {
			init: function () {
				return window.am4core;
        }
		},
		'lib/amcharts4/charts': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/charts',
			init: function () {
				return window.am4charts;
			}
		},
		'lib/amcharts4/maps': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/maps',
			init: function () {
				return window.am4maps;
			}
		},
		'lib/amcharts4/themes/animated': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/animated',
			init: function () {
				return window.am4themes_animated;
			}
		},
		'lib/amcharts4/themes/dataviz': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/dataviz',
			init: function () {
				return window.am4themes_dataviz;
			}
		},
		'lib/amcharts4/themes/material': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/material',
			init: function () {
				return window.am4themes_material;
			}
		},
		'lib/amcharts4/themes/kelly': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/kelly',
			init: function () {
				return window.am4themes_kelly;
			}
		},
		'lib/amcharts4/themes/dark': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/dark',
			init: function () {
				return window.am4themes_dark;
			}
		},
		'lib/amcharts4/themes/frozen': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/frozen',
			init: function () {
				return window.am4themes_frozen;
			}
		},
		'lib/amcharts4/themes/moonrisekingdom': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/moonrisekingdom',
			init: function () {
				return window.am4themes_moonrisekingdom;
			}
		},
		'lib/amcharts4/themes/spiritedaway': {
			deps: ['lib/amcharts4/core'],
			exports: 'lib/amcharts4/themes/spiritedaway',
			init: function () {
				return window.am4themes_spiritedaway;
			}
		},
		'lib/amcharts4/geodata/worldLow': {
			deps: ['lib/amcharts4/maps'],
			init: function () {
				return window.am4geodata_worldLow;
			}
		},
		"signalr.core": {
			deps: ["jquery"],
			exports: "$.connection"
		},
		"flatpickr": {
			"exports": "flatpickr"
		},
		"signalr.hubs": {
			deps: ["signalr.core"],
		},
		"flatpickr.fr": {
			"deps": ["flatpickr"]
		},
		"flatpickr.it": {
			"deps": ["flatpickr"]
		},
		"flatpickr.nl": {
			"deps": ["flatpickr"]
		}
	},

	deps: ["polyfill-focus-visible"] //load at require start


});

/*
 * Utile pour debug l'arbre de dépendances : https://gist.github.com/js-dot-js/3288778
 */
